module.exports = __webpack_public_path__ + "img/Temperus.9d46b6d6.png";